import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat,isFunction,findArrayObject } from '../../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
import JourneyTripActionDialog from '../../../components/Trip/JourneyTripActionDialog';
import TransactionDetailsSideBar from '../../../components/RightSideBar/TransactionDetailsSideBar';
import TripChargeDetailsCard from '../../../components/Payment/TripChargeDetailsCard';
import DeletePartyCharge from '../../../components/Trip/DeletePartyCharge';
import DeleteVendorDeduction from '../../../components/Trip/DeleteVendorDeduction';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    padding:"0 24px",
    display: 'flex',
    flexDirection:'column',
    alignItems: 'center',
    backgroundColor:'#fff',
    boxShadow:'none',
    marginTop:16
  },
  box:{
    width:'100%',
    //cursor:'pointer'
  },
  listBox:{
    width:'100%',
    backgroundColor:'#f1f1f3',
    padding:'18px 24px',
    marginTop:8,
    borderRadius:8,
    paddingRight:12,
  },
  icon:{
    fontSize:24,
    color:'#03c'
  },
  listLabel:{
    fontSize:14,
    fontWeight:'normal',
    color:'#0b1323',
    marginRight:24
  },
  amount:{
    color:'#0b1323',
    fontWeight:'normal',
    fontSize:14,
    marginRight:42,
    marginLeft:24
  },
  boxAmount:{
    color:'#0b1323',
    fontWeight:'normal',
    fontSize:14,
    marginRight:8,
  },
  sep:{
    borderTop:'1px dotted rgba(107, 119, 140, 0.25)',
    flexGrow:1,
    marginTop:5
  },
  sepIcon:{
    color:'#000',
    fontSize:6,
    opacity:0.25,
    margin:'0px 7px'
  },
  date:{
    fontSize:14,
    color:'#0b1323',
    fontWeight:600
  },
  paymentMode:{
    fontSize:14,
    color:'#0b1323',
  },
  paymentData:{
    fontSize:14,
    color:'rgba(11, 19, 35, 0.75);',
  },
  add:{
    color:'#03c',
    fontWeight:600,
    fontSize:14,
    cursor:'pointer'
  }
}));
const JourneyTripSupplierChargesCard = (props) => {
  const {trip,journey,updateJourney} = props;
  const classes = useStyles();
  let history = useHistory();
  let vendorTransactions = journey && journey.vendorTransactions ? journey.vendorTransactions:[];
  let transactions = vendorTransactions && vendorTransactions.charges?vendorTransactions.charges:[]
  let list = transactions && transactions.list? transactions.list.filter((trans)=>trans&&trans.transactionType != 'Vehicle_Hire_Cost'):[]
  let transData = findArrayObject("transactionType", 'Vehicle_Hire_Cost', transactions && transactions.list?transactions.list:null);
  let hireCost = transData&&transData.amount?Number(transData.amount):0 
  let tripDetails = trip;
  let tripId = tripDetails && tripDetails.id ? tripDetails.id:'';
  let vehicleData = journey && journey.vehicle ? journey.vehicle : {};
  let hiredTrip = journey && journey.vehicle && journey.vehicle.ownershipType && journey.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorId = hiredTrip && journey && journey.vendor && journey.vendor.vendorId ? journey.vendor.vendorId : 0;
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let partyBalance = tripDetails && tripDetails.balanceAmount ? tripDetails.balanceAmount : null;
  let vendorBalance = journey && journey.vendor && journey.vendor.vendorBalance ? journey.vendor.vendorBalance : null;
  let vendorSettled = hiredTrip && journey && journey.vendor && journey.vendor.isVendorSettled ? journey.vendor.isVendorSettled : false;
  //React State
  const [addOpen, setAddOpen] = useState(false);
  const [editOpen,setEditOpen] = useState(false);
  const [detailsOpen,setDetailsOpen] = useState(false);
  const [transactionData, setTransactionData] = useState({})
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editAction, setEditAction] = useState(null);
  let actionVisible = () => {
    if (hiredTrip) {
      return (tripStatus == 'PAYMENT_RECEIVED' && vendorSettled) ? false : true
    } else {
      return (tripStatus == 'PAYMENT_RECEIVED') ? false : true
    }
  }
  const [action,setAction] = useState(
    {
      action: 'add_charges',
      visible: actionVisible(),
      label: 'Add Charges',
      tabsFormat: true,
      eventName: 'Dweb Trip Charge Create Initiated',
      tabs: [
        {
          name: 'Party Charge',
          visible: true,
          disabled: tripStatus == 'PAYMENT_RECEIVED' ? true : false,
          person: 'party'
        },
        {
          person: 'supplier',
          disabled: vendorSettled,
          visible: hiredTrip,
          name: 'Supplier Charge'
        }
      ]
    });
    const handleActionSave = (status) => {
      /*if (isFunction(updateJourney) && journey.id) {
        updateJourney(journey.id)
      }*/
    }
    const handleaddTripActionClose = (status) => {
      setAddOpen(status);
      if (isFunction(updateJourney) && journey.id) {
        updateJourney(journey.id)
      }
    }
    const handleTransactionDetailsClose = () => {
      setDetailsOpen(false)
      if (isFunction(updateJourney) && journey.id) {
        updateJourney(journey.id)
      }
    }
    const handleEditCashflowActionClose = (status) => {
      setEditOpen(status)
      if (isFunction(updateJourney) && journey.id) {
        updateJourney(journey.id)
      }
    }
    const handleOnUpdateSuccess = (status) => {
      setEditOpen(status);
      setDetailsOpen(false)
      if (isFunction(updateJourney) && journey.id) {
        updateJourney(journey.id)
      }
    }
    const onEdit = (trans)=>{
      setTransactionData(trans);
      if(trans && trans.transactionParentType && trans.transactionParentType =='DEDUCTION' ){
        setEditAction({
          action: 'edit_vendor_reduction',
          label: 'Update Deduction',
          confirmText: 'Update Deduction',
          tabsFormat: false
        });
      }else{
        setEditAction({
          action: 'edit_vendor_charge',
          label: 'Update Charge',
          confirmText: 'Update Charge',
          tabsFormat: false
        });
      }
      setDetailsOpen(true)
    }
    const onDeleteSuccess = () => {
      setDeleteOpen(false);
      setDetailsOpen(false)
      if (isFunction(updateJourney) && journey.id) {
        updateJourney(journey.id)
      }
      setTransactionData(null)
    }
    const onDeleteCancel = () => {
      setDeleteOpen(false);
      /*setTransactionData(null)
      if (isFunction(updateJourney) && journey.id) {
        updateJourney(journey.id)
      }*/
    }
  return (
    <>
      <Paper component='div' className={classes.card} >
        <Box className={classes.box} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography className={classes.listLabel}>(+) Charges</Typography>
            {transactions.totalAmount ?<div className={classes.sep}></div>:null}
            <Typography className={classes.amount}>{numberFormat(transactions&&transactions.totalAmount?transactions.totalAmount-hireCost:0)}</Typography>
        </Box>
        {list && list.length>0 && <Box className={classes.listBox}>
          {list && list.map((trans,index)=>{
                return <>
                    <Box onClick={()=>{onEdit(trans)}} className={classes.box} marginBottom={'12px'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                      <Box display="flex" alignItems="center">
                        <Typography className={classes.date}>{moment(Number(trans.date*1000)).format("DD MMM YY")}</Typography>
                        {trans.paymentMode && <>
                          <FiberManualRecordIcon className={classes.sepIcon}/>
                          <Typography className={classes.paymentMode}>{trans.paymentMode}</Typography>
                        </>}
                        {trans.paymentData && <>
                          <FiberManualRecordIcon className={classes.sepIcon}/>
                          <Typography className={classes.paymentData}>{trans.paymentData}</Typography>
                        </>}
                        {trans.displayName && <>
                          <FiberManualRecordIcon className={classes.sepIcon}/>
                          <Typography className={classes.paymentData}>{trans.displayName}</Typography>
                        </>}
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Typography className={classes.boxAmount}>{numberFormat(trans.amount)}</Typography>
                        <ChevronRightIcon className={classes.icon}/>
                      </Box>
                    </Box>
                </>
            })}
            {actionVisible() && <Box className={classes.box} marginTop={'4px'}>
              <Typography onClick={()=>{setAddOpen(true)}}  className={classes.add}>Add Supplier Charge</Typography>
            </Box>}
        </Box>}
        {list && list.length==0 && actionVisible() && <Box className={classes.box} marginTop={'8px'}>
          <Typography onClick={()=>{setAddOpen(true)}}  className={classes.add}>Add Supplier Charge</Typography>
        </Box>}
      </Paper>
      {addOpen && <JourneyTripActionDialog defaultSelected={1} defaultPerson='supplier' action={action} journey={journey} updateJourney={updateJourney} selectedTrip={trip}  partyBalance={partyBalance} vendorBalance={vendorBalance} open={addOpen} onClose={handleaddTripActionClose} onSave={handleActionSave} />}
      {editOpen && <JourneyTripActionDialog action={editAction} journey={journey} updateJourney={updateJourney} selectedTrip={trip} editData={transactionData} open={editOpen} onClose={handleEditCashflowActionClose} onUpdateSuccess={handleOnUpdateSuccess} confirmText={editAction.confirmText ? editAction.confirmText : null} />}
      {deleteOpen && <DeleteVendorDeduction deleteOpen={deleteOpen} tripId={tripId} deleteId={transactionData.id} onDeleteSucees={onDeleteSuccess} onDeleteNo={onDeleteCancel} />}
      {detailsOpen && <TransactionDetailsSideBar
                rightSideBarOpen={detailsOpen}
                sideBarTitle={`Supplier ${transactionData && transactionData.transactionParentType?transactionData.transactionParentType.toLowerCase():''} Details`}
                data={transactionData}
                cStyle={true}
                onEdit={(!transactionData || vendorSettled || (transactionData && !transactionData.id) || (transactionData && transactionData.isBrokerEnabled)) ? null : (data) => {
                  setEditOpen(true)
                }}
                onDelete={(!transactionData || vendorSettled || (transactionData && !transactionData.id) || (transactionData && transactionData.isBrokerEnabled)) ? null : (data) => {
                   setDeleteOpen(true)
                }}
                //sideBarSecondaryTitle={null}
                handleSubmit={event => { }}
                toggleRightSideBar={handleTransactionDetailsClose}
            >
                <TripChargeDetailsCard
                    journey={journey} 
                    updateJourney={updateJourney} 
                    trip={trip}
                    data={transactionData}
                    type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                />
            </TransactionDetailsSideBar>}
    </>
  );
}
export default JourneyTripSupplierChargesCard;